module.exports = __webpack_public_path__ + "static/media/12590622611645005005005-train-station-1.38ea27b1.png";